"use client";
import React, { useEffect, useState } from "react";
import CourseCard, { Course } from "@/components/CourseCard";
import RegisterModal from "@/components/RegisterModal";

export default function LasPalmasPage() {
  const [courses, setCourses] = useState<Course[]>([]);
  const [selectedCourse, setSelectedCourse] = useState<Course | null>(null);

  useEffect(() => {
    fetch("/api/courses")
      .then((res) => res.json())
      .then((data) => {
        const filteredCourses = data.filter(
          (course: Course) => course.location === "Las Palmas de Gran Canaria" && !course.hidden
        );
        setCourses(filteredCourses);
      });
  }, []);

  return (
    <div className="section-spacing">
      <div className="container">
        <h1 className="text-3xl font-bold text-slate-800">Cursos en Las Palmas de Gran Canaria</h1>
        <div className="grid-courses mt-8">
          {courses.map((course) => (
            <CourseCard key={course.id} course={course} onRegister={setSelectedCourse} />
          ))}
        </div>
      </div>
      {selectedCourse && <RegisterModal course={selectedCourse} onClose={() => setSelectedCourse(null)} />} 
    </div>
  );
}
